<template>
    <div class="details-order">
        <b-container>
            <b-row>
                 <router-link :to=" { name: 'FormPage'}" class="btn-back"> Volver</router-link>
                <b-col cols="12" class="mb-4">
                    <h3><img class="icon" src="../../assets/imgs/icn_orderdetails.svg" alt=""> Detalles de la orden</h3>   
                </b-col>
                <span class="error-text">{{ messageError }}</span>
                <b-col md="4" class="mb-4">
                    <span>Hombre / Mujer</span>
                    <p>{{data.gender}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Nombre y Apellidos</span>
                    <p>{{data.name}} {{data.lastname1}} {{data.lastname2}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Especialidad</span>
                    <p>{{data.speciality}}<br>{{data.speciality2}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Nombre de la Empresa o Institución</span>
                    <p>{{data.hospital}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Número de consultorio</span>
                    <p>{{data.phoneOffice}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Día cumpleaños</span>
                    <p>{{data.dayBirth}}/{{ data.monthBirth }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" class="mb-4">
                    <table class="table b-table">
                        <thead role="rowgroup">
                            <tr>
                                <th>
                                    Producto
                                </th>
                                <th>
                                    Modelo
                                </th>
                                <th>
                                    Color
                                </th>
                                <th>
                                    Talla
                                </th>
                                <th>
                                    Cantidad
                                </th>
                            </tr>
                        </thead>
                        <tbody role="rowgroup">
                            <template v-for="(element) in arrayScrubs">
                                <tr v-if="element.size" role="row" :key="element.model">
                                    <td>
                                        {{element.type}}
                                    </td>
                                    <td>{{element.model}}</td>
                                    <td class="">{{element.color}}</td>
                                    <td class="">{{element.size}}</td>
                                    <td class="">{{element.qty}}</td>
                                    
                                </tr>
                            </template>
                            <template v-for="(element) in arrayPants">
                                <tr v-if="element.size" role="row" :key="element.model">
                                    <td>
                                        {{element.type}}
                                    </td>
                                    <td>{{element.model}}</td>
                                    <td class="">{{element.color}}</td>
                                    <td class="">{{element.size}}</td>
                                    <td class="">{{element.qty}}</td>
                                    
                                </tr>
                            </template>
                            <template v-for="(element) in arrayJackets">
                                <tr v-if="element.size" role="row" :key="element.model">
                                    <td>
                                        {{element.type}}
                                    </td>
                                    <td>{{element.model}}</td>
                                    <td class="">{{element.color.toString()}}</td>
                                    <td class="">{{element.size}}</td>
                                    <td class="">{{element.qty}}</td>
                                    
                                </tr>
                            </template>
                            <template v-for="(element) in arrayCoat">
                                <tr v-if="element.size" role="row" :key="element.model">
                                    <td>
                                        {{element.type}}
                                    </td>
                                    <td>{{element.model}}</td>
                                    <td class="">{{element.color}}</td>
                                    <td class="">{{element.size}}</td>
                                    <td class="">{{element.qty}}</td>
                                    
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </b-col>
                <b-col cols="12" class="mb-4">
                    <p class="note"><strong>NOTA.</strong> Toma en cuenta que en caso de solicitar bordado se usará de referencia el texto tal cual esté escrito en los siguientes campos. Respetaremos mayúsculas, minúsculas, acentos y cualquier otro caracter especial.</p>
                    <b-form-checkbox
                        id="checkbox-1"
                        v-model="status"
                        name="checkbox-1"
                        class="mt-2"
                        >
                        Confirmo y acepto que la información proporcionada es correcta
                        </b-form-checkbox>
                </b-col>
                <b-col md="6">
                    <b-button v-on:click.once="submitOrder">
                        <div v-if="!loading">Enviar orden</div>
                        <b-spinner v-else variant="light"></b-spinner>
                    </b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        props: {
            data: {
                type: Array,
                required: true
            },
            arrayJackets: {
                type: Array,
                required: true
            },
            arrayScrubs: {
                type: Array,
                required: true
            },
            arrayPants: {
                type: Array,
                required: true
            },
            arrayCoat: {
                type: Array,
                required: true
            }
        },
        created() {
            var datalist = sessionStorage.getItem('dataUser')
            if (!this.data) {
                this.data = JSON.parse(datalist)
                this.arrayJackets = JSON.parse(sessionStorage.getItem('arrayJackets'))
                this.arrayJackets.forEach(function(value, index, array){
                    array[index].color = value.color.toString()
                });
                this.arrayScrubs = JSON.parse(sessionStorage.getItem('arrayScrubs'))
                this.arrayPants = JSON.parse(sessionStorage.getItem('arrayPants'))
                this.arrayCoat = JSON.parse(sessionStorage.getItem('arrayCoat'))
            }
            if (!this.data){
                this.$router.push('/orden')
            }
        },
        data() {
            return {
                status: '',
                loading: false,
                messageError: ''
            }
        },
        methods: {
            submitOrder() {
                var token = sessionStorage.getItem('api_token')
                var id_user = sessionStorage.getItem('id_user')
                let array_model = []
                array_model = this.arrayJackets.concat(this.arrayScrubs, this.arrayPants, this.arrayCoat)
                array_model = array_model.filter((x) =>
                    !(x.size == null | x.size == ''))
                
                array_model.forEach(function(value, index, array){
                    array[index].embroidFont = value.embroidFont ? value.embroidFont.text : ''
                    array[index].embroidFontColor = value.embroidFontColor ? value.embroidFont.name : ''
                    array[index].color = value.color.toString()
                    array[index].embroidPosition = value.embroidPosition ? value.embroidPosition.text : ''
                    array[index].logoPosition = value.logoPosition ? value.logoPosition.text : ''
                });

                this.loading = true
                if(this.status){
                    let formData = new FormData()
                    formData.append('api_token', token)
                    formData.append('user_id', id_user)
                    formData.append('option', 'new_order')
                    formData.append('collaborator_number', this.data.collaborator)
                    formData.append('id_collaborator', this.data.idCollaborator)
                    formData.append('order_name', this.data.name)
                    formData.append('order_firstLastname', this.data.lastname1)
                    formData.append('order_secondLastname', this.data.lastname2)
                    formData.append('order_specialty', this.data.speciality)
                    formData.append('order_specialty2', this.data.speciality2)
                    formData.append('order_area', this.data.area)
                    formData.append('order_hospital', this.data.hospital)
                    formData.append('order_id_hospital', this.data.id_hospital)
                    formData.append('order_dayBirth', this.data.dayBirth)
                    formData.append('order_monthBirth', this.data.monthBirth)
                    formData.append('order_mail', this.data.email)
                    formData.append('order_phone', this.data.phone)
                    formData.append('order_phone_office', this.data.phoneOffice)
                    formData.append('order_gender', this.data.gender)
                    formData.append('image_all', 'No')
                    formData.append('image', [])
                    array_model.forEach(function(value){
                        formData.append('logo_'+value.type+'_'+value.id, value.logoFile)
                    });
                    formData.append('items_array', JSON.stringify(array_model))

                    axios
                    .post(
                        process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        },
                    )
                    .then((response) => {
                        this.loading = true
                        if (!response.data.error.code && response.data.order) {
                            sessionStorage.removeItem('dataUser')
                            sessionStorage.setItem('dataOrder',JSON.stringify(response.data.order))
                            this.$router.push({ name: 'ConfirmationOrder', params: { data: response.data.order}})
                        } else {
                            this.loading = false
                            this.messageError = response.data.error.description
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                }
            }
        }
    }
</script>

<style scoped>
.details-order{
    padding: 70px 15%;
}
h3{
    font-weight: bold;
    font-size: 25px;
}
span{
    font-size: 16px;
    color: #5965B1;
}
p{
   font-size: 20px; 
}
.note{
    font-size: 14px;
    color: #5965B1;
}
.btn,
.btn:focus,
.btn:hover{
    background: #F15E1A;
    border: none;
    width: 100%;
}
.icon{
    margin-top: -5px;
}
.btn-back{
    position: absolute;
    left: 10%;
    text-decoration: none;
    color: #5965B1;
    border: 1px solid #5965B1;
    width: fit-content;
    padding: 5px 20px;
    border-radius: 5px;
}
@media (max-width: 1600px) {
    .details-order{
        padding: 50px 15%;
    }
    .details-order .container{
        padding: 0 11%;
    }
    h3{
        font-size: 18px;
    }
    span{
        font-size: 12px;
    }
    p{
        font-size: 15px; 
    }
    .note{
        font-size: 11px;
    }
    .icon{
        width: 20px;
        margin-right: 5px;
    }
}
@media (max-width: 768px) {
    .details-order{
        padding: 50px 5% 50px 5%
    }
    .btn-back{
        position: relative;
        left: 0;
        margin-bottom: 20px;
    }
}
</style>